import { ApolloClient, NormalizedCacheObject } from '@apollo/client'
import {
  AdminRewardsFactory,
  JointCampaignFactory,
  LiquidityCampaignFactory,
  LiquidityCampaignV2Factory,
  RewardCampaignFactory,
} from '@arcxgame/contracts/dist/src/typings'
import { Signer } from 'ethers'
import { RewardPoolDetails } from 'src/config/Config'
import { getAddressesForNetwork } from 'src/config/getAddressesForNetwork'
import ArcFarm from './ArcFarm'
import { JointCampaignFarm } from './JointCampaignFarm'
import { RewardCampaignFarm } from './RewardCampaignFarm'
import _ from 'lodash'
import { LiquidityCampaignFarm } from './LiquidityCampaignFarm'
import { Network } from 'src/config'
import { AdminRewardsFarm } from './AdminRewardsFarm'
import { LiquidityCampaignV2Farm } from './LiquidityCampaignV2Farm'

export class ArcFarmFactory {
  static new(
    farmDetails: RewardPoolDetails,
    signer: Signer,
    network: Network,
    client: ApolloClient<NormalizedCacheObject>,
    isPlaynet = false,
  ): ArcFarm {
    const allAddresses = getAddressesForNetwork(network, isPlaynet)

    const deploymentInfo = _.find(allAddresses, ({ group, type, source }) => {
      return type === 'staking' && group === farmDetails.name && source !== 'ArcProxy'
    })
    const farmSource = deploymentInfo?.source

    const proxyContract = _.find(allAddresses, ({ group, type, source }) => {
      return type === 'staking' && group === farmDetails.name && source === 'ArcProxy'
    })

    let farmAddress: string
    if (proxyContract) {
      farmAddress = proxyContract.address
    } else {
      farmAddress = deploymentInfo.address
    }

    switch (farmSource) {
      case 'JointCampaign':
        return new JointCampaignFarm(
          farmDetails.name,
          farmDetails.platform,
          farmDetails.pair,
          farmDetails.pairLink,
          farmDetails.note,
          signer,
          network,
          JointCampaignFactory.connect(farmAddress, signer),
          client,
        )
      case 'LiquidityCampaign':
        return new LiquidityCampaignFarm(
          farmDetails.name,
          farmDetails.platform,
          farmDetails.pair,
          farmDetails.pairLink,
          farmDetails.note,
          signer,
          network,
          LiquidityCampaignFactory.connect(farmAddress, signer),
          client,
        )
      case 'LiquidityCampaignV2':
        return new LiquidityCampaignV2Farm(
          farmDetails.name,
          farmDetails.platform,
          farmDetails.pair,
          farmDetails.pairLink,
          farmDetails.note,
          signer,
          network,
          LiquidityCampaignV2Factory.connect(farmAddress, signer),
          client,
        )
      case 'AdminRewards':
        return new AdminRewardsFarm(
          farmDetails.name,
          farmDetails.platform,
          farmDetails.pair,
          farmDetails.pairLink,
          farmDetails.note,
          signer,
          network,
          AdminRewardsFactory.connect(farmAddress, signer),
          client,
        )
      default:
      case 'RewardCampaign':
        return new RewardCampaignFarm(
          farmDetails.name,
          farmDetails.platform,
          farmDetails.pair,
          farmDetails.pairLink,
          farmDetails.note,
          signer,
          network,
          RewardCampaignFactory.connect(farmAddress, signer),
          client,
        )
    }
  }
}
